<template>
    <section class="md-evaluation-banner-progress layout-banner-progress">
        <template
            v-for="(stepItem, index) in originStepData"
            :key="stepItem.name"
        >
            <div class="split-line" v-if="index > 0"></div>
            <div
                class="md-evaluation-layout-step-item"
                :class="{
                    selected: stepItem.step == step
                }"
            >
                <div class="step-icon-wrap">
                    <span class="step-icon" :style="stepIconStyle">{{
                        showNumStep ? index + 1 : ''
                    }}</span>
                </div>
                <span class="step-label" v-if="showStepLabel">{{
                    stepItem.label
                }}</span>
                <div class="step-desc">
                    {{ stepItem.desc }}
                </div>
            </div>
        </template>
    </section>
</template>

<script>
export default {
    i18next: {
        ns: 'md-evaluation-banner'
    },
    props: {
        step: {
            type: [Number, String],
            default: 0
        },
        simpleMode: {
            type: Boolean,
            default: false
        },
        isSkipStep2: {
            type: Boolean,
            default: false
        },
        showNumStep: {
            type: Boolean,
            default: true
        },
        showStepLabel: {
            type: Boolean,
            default: false
        },
        iconStyle: {
            type: Object
        }
    },
    computed: {
        stepIconStyle({ iconStyle }) {
            return iconStyle ?? {};
        },
        stepData() {
            return [
                {
                    step: 0,
                    name: 'step1',
                    label: this.$t('md-evaluation-banner.step1'),
                    desc: this.$t('md-evaluation-banner.enterPropertyAddress'),
                    show: true
                },
                {
                    step: 1,
                    name: 'step2',
                    label: this.$t('md-evaluation-banner.step2'),
                    desc: this.$t('md-evaluation-banner.propertyDetails'),
                    show: !this.isSkipStep2
                },
                {
                    step: 2,
                    name: 'step3',
                    label: this.isSkipStep2
                        ? this.$t('md-evaluation-banner.step2')
                        : this.$t('md-evaluation-banner.step3'),
                    desc: this.$t('md-evaluation-banner.propertyValuation'),
                    show: true
                }
            ].filter(item => item.show);
        },
        simpleStepData() {
            return [
                {
                    step: 0,
                    name: 'step1',
                    label: this.$t('md-evaluation-banner.step1'),
                    desc: this.$t('md-evaluation-banner.enterPropertyAddress')
                },
                {
                    step: 2,
                    name: 'step2',
                    label: this.$t('md-evaluation-banner.step2'),
                    desc: this.$t('md-evaluation-banner.getPropertyEvaluation')
                }
            ];
        },
        originStepData({ simpleMode, simpleStepData, stepData }) {
            return simpleMode ? simpleStepData : stepData;
        }
    }
};
</script>
<style lang="scss">
@import '@/theme/media.scss';
@import '@/theme/mixin.scss';
.md-evaluation-banner-progress.layout-banner-progress {
    display: flex;
    width: 100%;
    .split-line {
        margin-top: 30px;
        height: 1px;
        flex: 1;
        background: rgba(255, 255, 255, 0.3);
        @include media-600 {
            margin-top: 20px;
        }
    }
    .md-evaluation-layout-step-item {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        row-gap: 15px;
        .step-icon-wrap {
            display: flex;
            align-items: center;
            width: 100%;
            &::before,
            &::after {
                content: '';
                flex: 1;
                display: block;
                height: 1px;
                background: rgba(255, 255, 255, 0.3);
            }
        }
        .step-icon {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            width: 61px;
            height: 61px;
            border-radius: 50%;
            font-size: 18px;
            color: #fff;
            background: rgba(255, 255, 255, 0.3);
            @include media-600 {
                width: 41px;
                height: 41px;
            }
        }
        .step-desc {
            font-size: 14px;
            font-weight: 500;
            line-height: 1.5;
            color: #fff;
            text-align: center;
            padding: 0 40px;
            @include media-600 {
                padding: 0 5px;
            }
        }
        &.selected {
            .step-icon {
                color: #191919;
                background: rgba(255, 255, 255, 1);
            }
        }
        &:first-child {
            .step-icon-wrap {
                &::before {
                    opacity: 0;
                }
            }
        }
        &:last-child {
            .step-icon-wrap {
                &::after {
                    opacity: 0;
                }
            }
        }
    }
}
</style>
